const loginTemplate = {
  event: 'login', // A default GA4 event
  redirect: null, // The unencoded value available in the URL, if any
  method: null, // One of “stubhub”, “facebook”, “apple”
  visit_guid: null, // The GUID / user_cookie_guid of the user that just logged in
};

export default loginTemplate;
